// Copyright 2017 Sorama B.V.

export class DOMExtensions {
    public static errorFromDOMException(e: DOMException): Error | DOMException {
        if (e.name && typeof e.name === "string") {
            console.error("DOMException: " + e.name);

            // See: https://developer.mozilla.org/en-US/docs/Web/API/DOMException
            switch (e.name) {
                case "IndexSizeError":
                    return new Error("The index is not in the allowed range.");
                case "HierarchyRequestError":
                    return new Error("The node tree hierarchy is not correct.");
                case "WrongDocumentError":
                    return new Error("The object is in the wrong Document.");
                case "InvalidCharacterError":
                    return new Error("The string contains invalid characters.");
                case "NoModificationAllowedError":
                    return new Error("The object can not be modified.");
                case "NotFoundError":
                    return new Error("The object can not be found.");
                case "NotSupportedError":
                    return new Error("The operation is not supported.");
                case "InvalidStateError":
                    return new Error("The object is in an invalid state.");
                case "SyntaxError":
                    return new Error("The string did not match the expected pattern.");
                case "InvalidModificationError":
                    return new Error("he object can not be modified in this way.");
                case "NamespaceError":
                    return new Error("The operation is not allowed by Namespaces in XML.");
                case "InvalidAccessError":
                    return new Error("The object does not support the operation or argument.");
                case "TypeMismatchError":
                    return new Error("The type of the object does not match the expected type.");
                case "SecurityError":
                    return new Error("The operation is insecure.");
                case "NetworkError":
                    return new Error("A network error occurred.");
                case "AbortError":
                    return new Error("The operation was aborted.");
                case "URLMismatchError":
                    return new Error("The given URL does not match another URL.");
                case "QuotaExceededError":
                    return new Error(
                        "There is insufficient storage available on your computer to complete this operation"
                    );
                case "TimeoutError":
                    return new Error("The operation timed out.");
                case "InvalidNodeTypeError":
                    return new Error("The node is incorrect or has an incorrect ancestor for this operation.");
                case "DataCloneError":
                    return new Error("The object can not be cloned.");
                case "EncodingError":
                    return new Error("The encoding or decoding operation failed");
                case "NotReadableError":
                    return new Error("The input/output read operation failed");
                case "UnknownError":
                    return new Error("The operation failed for an unknown transient reason.");
                case "ConstraintError":
                    return new Error(
                        "A mutation operation in a transaction failed because a constraint was not satisfied."
                    );
                case "DataError":
                    return new Error("Provided data is inadequate.");
                case "TransactionInactiveError":
                    return new Error(
                        "A request was placed against a transaction which is currently not active, or which is finished."
                    );
                case "ReadOnlyError":
                    return new Error("The mutating operation was attempted in a 'readonly' transaction.");
                case "VersionError":
                    return new Error(
                        "An attempt was made to open a database using a lower version than the existing version."
                    );
                case "OperationError":
                    return new Error("The operation failed for an operation-specific reason.");
                case "NotAllowedError":
                    return new Error(
                        "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission."
                    );
            }
        }

        return e;
    }

    public static getElementAvailableSize(element: HTMLElement): number {
        let totalSize = element.clientHeight;
        for (let i = 0; i < element.childNodes.length; i++) {
            const child = <HTMLElement>element.childNodes.item(i);
            totalSize -= child.clientHeight !== undefined ? child.clientHeight : 0;
        }

        return totalSize;
    }
}
